<template>
  <div class="demo-spin-article">

    <Row class="btn-back"  @click.native="$router.push({ name: 'integrations' })">
      <Icon type="ios-arrow-back" />
      <h2>Light POS</h2>
    </Row>

    <Row class="integration-container" type="flex" justify="end" align="bottom" :gutter="48">

      <div class="img-box">
        <img src="/static/img/integrations/light-pos.png" alt="">
      </div>

      <Col :xs="24" :sm="24" :md="16" :xl="14">
        <div class="card-container">
          <div class="mobile-img">
            <img src="/static/img/integrations/light-pos__mobile.jpeg" alt="" class="img__mobile">
          </div>

          <div class="card__body">
            <div class="card-title">
              Модуль Light POS
            </div>

            <p>
              Light POS - это современное и компактное решение для вашего
              бизнеса на базе ОС Android.
            </p>

            <p>
              В одном устройстве вы получаете:
            </p>

            <ul>
              <li class="font-bold">Фискальную онлайн-кассу (внесена в гос.реестр №219)</li>
              <li class="font-bold">Принтер чеков</li>
              <li class="font-bold">Банковский POS-терминал</li>
              <li class="font-bold">Сканер штрихкода</li>
            </ul>

            <p>
              Принимайте быстрые и безопасные платежи от клиентов.
              Стоимость 139 000 тенге с годовой лицензией онлайн-кассы в подарок.
            </p>

            <div align="right">
              <a href="https://www.lkassa.kz/" target="_blank">
                узнать больше
              </a>
            </div>
          </div>


        </div>
      </Col>

      <Col :xs="24" :sm="24" :md="8" :xl="7">
        <moduleForm refPage="LIGHT_POS"></moduleForm>
      </Col>

    </Row>
  </div>
</template>

<script>
    import moduleForm from "./moduleForm.vue";


    export default {
        name: "baseApp",
        data() {
            return {};
        },
        components: {
            moduleForm
        }
    }
</script>

<style scoped>

  .demo-spin-article {
    position: relative;
  }
  .btn-back {
    display: inline-flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: -200px;
    z-index: 52;
    cursor: pointer;
  }
  .btn-back h2 {
    padding-left: 24px;
  }

  .integration-container {
    padding-top: 30px;
    padding-bottom: 30px;
    position: relative;
    z-index: 51;
  }
.card-container {
  background-color: #F1F1F1;
  padding: 50px 80px 50px 130px
}

.card-container .card-title {
  font-size: 30px;
  margin-bottom: 40px;
}
.card-container p, .card-container ul, .card-container li {
  margin-bottom: 30px;
}
.card-container ul {
  padding-left: 30px;
}

  .card-container a {
    color: #5087DE;
    text-decoration: underline;
  }

  .img-box {
    position: absolute;
    left: -190px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 53;
    width: calc(280px + 13%);
  }
  .img-box img {
    width: 100%;
  }

  .img__mobile {
    display: none;
  }

  @media screen and (max-width: 1900px) {
    .btn-back {
      left: -180px;
    }
    .img-box {
      left: -160px;
    }
  }

  @media screen and (max-width: 1500px) {
    .btn-back {
      left: -140px;
    }
    .img-box {
      left: -120px;
      width: calc(220px + 13%);
    }
  }


  @media screen and (max-width: 1200px) {
    .btn-back {
      left: 0;
    }

    .integration-container {
      padding-top: 50px;
    }

    .img-box {
      display: none;
    }

    .card-container {
      padding: 0;
      overflow: hidden;
    }

    .img__mobile {
      display: block;
      width: 100%;
    }

    .card-container .card__body {
      padding: 20px;
    }

  }

  @media screen and (max-width: 767px) {
    .card-container {
      margin-bottom: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/integrations/moduleLightPos.vue